import script from "./aboutCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./aboutCarousel.vue?vue&type=script&setup=true&lang=js"

import "./aboutCarousel.vue?vue&type=style&index=0&id=3c09e3dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c09e3dc"]])

export default __exports__